export const normalizeTicketCountBadge = (value) => {
	if (value == null || value === "" || value === 0 || value === "0") {
		return { show: false, label: "" };
	}

	const raw = String(value).trim();
	const numeric = parseInt(raw.replace(/[^\d]/g, ""), 10) || 0;

	if (numeric <= 0) {
		return { show: false, label: "" };
	}

	if (raw.includes("+")) {
		return {
			show: true,
			label: numeric > 99 ? "99+" : `${numeric}+`,
		};
	}

	return {
		show: true,
		label: numeric > 99 ? "99+" : String(numeric),
	};
};
